import { executeSolanaTransaction } from '../..';
import { JUPITER_ERRORS, SolanaLogsError } from './errorPatterns';
export const jupiterSwapper = {
    executeSolanaTransaction: async (txToSign, callbacks) => {
        try {
            const txid = await executeSolanaTransaction(txToSign, callbacks);
            return txid;
        }
        catch (e) {
            if (e instanceof Error) {
                const errorMessage = e.message;
                const swapperErrorType = Object.keys(JUPITER_ERRORS).reduce((acc, errorPattern) => {
                    if (errorMessage.includes(errorPattern)) {
                        acc = JUPITER_ERRORS[errorPattern];
                    }
                    return acc;
                }, undefined);
                if (swapperErrorType)
                    throw new SolanaLogsError(swapperErrorType);
            }
            throw e;
        }
    },
};
